<template>
    <div
        ref="dropdown"
        class="dunning-dropdown"
    >
        <button
            type="button"
            class="kgr-table__action"
            :disabled="allLevelsDisabled"
            @click="toggleMenu"
        >
            <kgr-icon
                icon-class="euro"
                :disabled="allLevelsDisabled"
                :title="getExtendedDunningTitle()"
                :style="!allLevelsDisabled ? { color: getDunningColor() } : {}"
            />
        </button>

        <div
            v-if="menuOpen && !dunningDisabled"
            class="dropdown-menu"
        >
            <button
                v-for="dunningLevel in dunningLevels"
                :key="dunningLevel"
                type="button"
                class="kgr-table__action"
                :disabled="isLevelDisabled(dunningLevel)"
                @click="handleMenuClick(dunningLevel)"
            >
                <kgr-icon
                    icon-class="euro"
                    :disabled="isLevelDisabled(dunningLevel)"
                    :title="getDunningTitle(dunningLevel)"
                    :style="!isLevelDisabled(dunningLevel) ? { color: getDunningColor(dunningLevel) } : {}"
                />
            </button>
        </div>
    </div>
</template>

<script>
import ClubDunningSettings from '../../../js/dto/ClubDunningSettings.js';
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import ClubTransactionInvoice from '../../../js/dto/ClubTransactionInvoice.js';
import DunningChecker from '../../../js/accounting/DunningChecker.js';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        value: {
            required: true,
            validator(value) {
                return value instanceof ClubInvoice || value instanceof ClubTransactionInvoice;
            },
        },
        dunningDisabled: {
            required: true,
            type: Boolean,
        },
        dunningChecker: {
            type: DunningChecker,
            required: true,
        },
    },
    data() {
        return {
            dunningLevels: [
                ClubDunningSettings.NONE,
                ClubDunningSettings.LEVEL1,
                ClubDunningSettings.LEVEL2,
                ClubDunningSettings.LEVEL3,
                ClubDunningSettings.LEVEL4,
            ],
            menuOpen: false,
            helper: new Helper(),
        };
    },
    computed: {
        allLevelsDisabled() {
            return this.dunningChecker.isDunningDisabledForInvoice(this.value, true);
        },
    },
    created() {
        this.invoiceId = this.value instanceof ClubInvoice ? this.value.id : this.value.invoiceId;
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        getDunningColor(status) {
            switch (status !== undefined ? status : this.value.dunningStatus.status) {
                case ClubDunningSettings.NONE:
                    return 'green';
                case ClubDunningSettings.LEVEL1:
                    return '#E8F773';
                case ClubDunningSettings.LEVEL2:
                    return '#EAD053';
                case ClubDunningSettings.LEVEL3:
                    return '#EC7D22';
                case ClubDunningSettings.LEVEL4:
                    return 'red';
            }
        },
        getDunningTitle(status) {
            return this.helper.translateDunningStatus(status !== undefined ? status : this.value.dunningStatus.status);
        },
        getExtendedDunningTitle() {
            let title = this.getDunningTitle();
            if (this.value.dunningStatusMessage !== null) {
                title += `\n\n${this.value.dunningStatusMessage}`;
            }
            return title;
        },
        isLevelDisabled(dunningLevel) {
            return this.dunningChecker.isDunningLevelDisabledForInvoice(this.value, dunningLevel);
        },
        emitDunningLevelChanged(dunningLevel) {
            this.$emit('dunningLevelChanged', { invoiceId: this.invoiceId, dunningLevel });
        },
        toggleMenu() {
            if (!this.dunningDisabled && !this.allLevelsDisabled) {
                this.menuOpen = !this.menuOpen;
            }
        },
        handleMenuClick(dunningLevel) {
            this.emitDunningLevelChanged(dunningLevel);
            this.menuOpen = false; // Close menu after click
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.dropdown;
            if (dropdown && !dropdown.contains(event.target)) {
                this.menuOpen = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.dunning-dropdown {
    position: relative;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
}
.dropdown-menu {
    position: absolute;
    bottom: 100%;
    left: 0;
    margin-bottom: 5px;
    background: var(--kgr-color-surface-raised);
    border: 1px solid var(--kgr-color-border);
    padding: 4px;
    display: flex;
    flex-direction: row;
    z-index: 10;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}
</style>
